import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Container, Typography } from '@mui/material';

class PersonTransactions extends Component {
  componentDidMount() {
    // const personId = this.props.match?.params?.id;
  }

  render() {
    return (
      <Container>
        <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em' }}>Person {this.props.match?.params?.id} Transactions</Typography>
      </Container>
    );
  }
}

PersonTransactions.propTypes = {
  match: PropTypes.object.isRequired
};

export default withRouter(PersonTransactions);
